import React, { Component } from 'react';
import { Route, Switch, BrowserRouter as Router, Link } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import Home from '../home/Home';
import Order from '../order/Order';
import Map from '../map/Map';
import Status from '../status/Status';
import Payment from '../payment/Payment';
import About from '../about/About';
import Test from '../test/Test';
import Qna from '../qna/Qna';
import Faq from '../faq/Faq';
import Thankyou from '../thankyou/Thankyou';
import Contact from '../contact/Contact';

import './Css';
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

//import 'react-notifications/lib/notifications.css';
//import {NotificationContainer} from 'react-notifications';

import { ErrorBoundary } from 'react-error-boundary';
import logo from './css/img/logo.png';
import logo2 from './css/img/logo-3.png';

class App extends Component {
  async componentDidMount() {
    let body_class = ['apps-gotlocked-video-banner', 'apps-gotlocked-order'];
    document.body.classList.add(...body_class);
    this.startErrorLog();
  }

  startErrorLog() {
    window.onerror = (message, file, line, column, errorObject) => {
      column = column || (window.event && window.event.errorCharacter);
      var stack = errorObject ? errorObject.stack : null;

      //trying to get stack from IE
      if (!stack) {
        var stack = [];
        var f = arguments.callee.caller;
        while (f) {
          stack.push(f.name);
          f = f.caller;
        }
        errorObject['stack'] = stack;
      }

      var data = {
        title: "Website error",
        message: message,
        file: file,
        line: line,
        column: column,
        errorStack: stack,
      };
      
      fetch('https://logs-01.loggly.com/inputs/1e0bb7b5-3e09-4d11-9534-d4268d2a87d4/tag/http/', {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          //"Access-Control-Allow-Origin": "*",
          //"Access-Control-Allow-Methods": "POST, OPTIONS"
        }
      });
      return false;
    }
  }

  render() {
    return (
      <Provider store={Store}>
        <div className="preloader"></div>
        <Router basename="/findlocksmith">
          <header className="apps-gotlocked-main-menu-area">
            <div className="container container2">
              <div className="row">
                <div className="col-md-2 col-sm-2 col-xs-6">
                  <div className="apps-gotlocked-logo">
                    <a href="https://gotlocked.com/">
                      <img src={logo2} />
                    </a>
                  </div>
                </div>
                <div className="col-md-10 col-sm-10 col-xs-12" style={{height: "1px"}}>
                  <div className="apps-gotlocked-menu-and-serach clear-both">
                    <span id="apps-gotlocked-main-menu-icon">
                      <div className="la-ball-elastic-dots la-2x item-generate">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </span>
                    <nav id="apps-gotlocked-menu" className="apps-gotlocked-menu">
                      <ul>
                        <li><a href="https://gotlocked.com/">Home</a></li>
                        <li><Link to="/order">Find a Locksmith</Link></li>
                        <li><Link to="/status">Check Order Status</Link></li>
                        <li><a href="https://gotlocked.com/#features">Features</a></li>
                        <li><a href="https://gotlocked.com/#testimonials">Testimonials</a></li>
                        <li><a href="https://gotlocked.com/#faq">FAQ</a></li>
                        <li><a href="https://gotlocked.com/blog">Blog</a></li>
                        <li style={{visibility: 'hidden'}}><Link to="/map">Map</Link></li>
                        <li style={{visibility: 'hidden'}}><Link to="/payment">Payment</Link></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <Switch>
            <Route exact path="/">
              <Order />
            </Route>
            <Route path="/order">
              <Order />
            </Route>
            <Route path="/map">
              <Map />
            </Route>
            <Route path="/payment">
              <Payment />
            </Route>
            <Route path="/status">
              <Status />
            </Route>
            <Route path="/thankyou">
              <Thankyou />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/faq">
              <Faq />
            </Route>
            <Route path="/Qna">
              <Qna />
            </Route>
            <Route path="/test">
              <Test />
            </Route>
          </Switch>
          <footer className="apps-gotlocked-footer-section" id="apps-gotlocked-footer">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  {/* <div className="apps-gotlocked-footer-logo-and-social">                  
                  <div className="apps-gotlocked-social-link wow fadeInUp" data-wow-delay=".4s">
                    <ul>
                      <li><a href="#"><i className="zmdi zmdi-facebook zmdi-hc-fw"></i></a></li>
                      <li><a href="#"><i className="zmdi zmdi-google-plus zmdi-hc-fw"></i></a></li>
                      <li><a href="#"><i className="zmdi zmdi-twitter zmdi-hc-fw"></i></a></li>
                    </ul>
                  </div>
                </div> */}
                  <div className="apps-gotlocked-footer-menu-and-copyright-txt clear-both">
                    <div className="apps-gotlocked-copyright-txt wow fadeInUp" data-wow-delay=".6s">
                      <p>&copy; 2020 GotLocked. All Right Reserved</p>
                    </div>
                    {/* <nav className="apps-gotlocked-footer-menu wow fadeInUp" data-wow-delay=".8s">
                      <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/order">Find a Locksmith</Link></li>
                        <li><Link to="/test">Testimonials</Link></li>
                        <li><Link to="/qna">Question?</Link></li>
                        <li><Link to="/faq">FAQ</Link></li>
                        <li><Link to="/about">About</Link></li>
                      </ul>
                    </nav> */}
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <ReactNotification />
        </Router>
      </Provider>
    );
  }
}

export default App;